<script lang="ts" setup>
const documentId = inject("documentId") as any;
const documentParagraphsStore = useDocumentParagraphsStore(documentId);
const { isMergingParagraphs, paragraphsToMerge } = storeToRefs(
  documentParagraphsStore
);

const containerRef = ref();

const windowWidthStore = useWindowWidth();
const { windowWidth } = storeToRefs(windowWidthStore);

const left = computed(() => {
  const documentElement = document.getElementById("document-container");

  if (!documentElement) return 0;

  const documentRect = documentElement.getBoundingClientRect();

  if (!documentRect) return 0;

  const center = documentRect.width / 2;

  const containerElement = containerRef.value as HTMLElement | undefined;

  if (!containerElement) return center;

  const containerRect = containerElement.getBoundingClientRect();

  if (!containerRect) return center;

  return (
    documentRect.left + center - containerRect.width / 2 - windowWidth.value * 0
  );
});

const isMerging = ref(false);

const mergeParagraphs = async () => {
  isMerging.value = true;
  await documentParagraphsStore.mergeParagraphs();
  isMerging.value = false;
};
</script>

<template>
  <TransitionsFade>
    <div
      v-if="isMergingParagraphs"
      ref="containerRef"
      class="rounded bg-surface shadow p-4 fixed bottom-4"
      :style="{
        left: left + 'px',
      }"
    >
      <BaseButton
        :disabled="paragraphsToMerge.length < 2"
        @click="mergeParagraphs"
        :show-spinner="isMerging"
      >
        Merge Paragraphs ({{ paragraphsToMerge.length }})
      </BaseButton>
      <BaseTextButton
        @click="documentParagraphsStore.stopMerging()"
        color="danger"
      >
        cancel
      </BaseTextButton>
    </div>
  </TransitionsFade>
</template>

<style scoped></style>
